export const mapDomainsToBackEnd = (
	domains?: { id: number; text: string }[],
): string[] => {
	if (!domains) return [];

	return domains?.map(({ text }) => text);
};

export const mapDomainsFromBackEnd = (
	domains?: string[],
): { id: number | string; text: string }[] => {
	if (!domains) return [];

	return domains?.map(domain => ({ id: domain, text: domain }));
};

export const isEmailAllowed = (
	email: string,
	allowedDomains: string[],
): boolean => {
	if (email === "" || !email || allowedDomains.length === 0) return true;

	const emailDomain = email?.split("@")?.[1]?.toLowerCase();

	return allowedDomains
		?.map(domain => domain?.toLowerCase())
		?.includes(emailDomain);
};
